import { widgetFilterSchema } from '../../common/schema'
import { okOrThrow } from '../../common/http'
import { homerunnerApiBaseUrl } from '../../hr'
import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

export const amenitiesParamsSchema = widgetFilterSchema.extend({
  feed_id: z.number().int().describe('Filter amenities by feed ID'),
  platform: z.string().nullish().describe('Filter amenities by platform UUID'),
  property: z.string().describe('Filter amenities by property slug'),
}).describe('Data filter options for amenities')

export type AmenitiesFilter = z.infer<typeof amenitiesParamsSchema>

export type Amenity = {
  id: number
  name: string
  icon_class?: string | null
}

export async function fetchAmenities(filter: AmenitiesFilter) {
  const url = new URL(`${homerunnerApiBaseUrl()}/public-api/v1/property-amenities`)
  Object.entries(filter).forEach(([key, value]) => {
    if (value !== undefined && value !== null) url.searchParams.append(key, String(value))
  })
  const res = await fetch(url.toString())
  await okOrThrow(res, 'Failed to fetch property amenities')
  const data = await res.json()

  return {
    ...data,
  } as {
    status: 'ok' | 'error'
    result: { amenities: Amenity[] }
    status_code: number
  }
}

export function useFetchAmenities(filter: AmenitiesFilter) {
  return useQuery({
    queryKey: ['amenities', filter],
    queryFn: () => fetchAmenities(filter),
  })
}
